import React, { useMemo } from "react";
import { useHoverHandlerContext } from "./context";

interface IHoverHandlerProps {
  children: React.ReactElement | React.FunctionComponent<{ onMouseEnter: () => void; onMouseLeave: () => void }>;
}

export const HoverHandler = ({ children }: IHoverHandlerProps) => {
  const { handleParentMouseEnter, handleParentMouseLeave } = useHoverHandlerContext();

  const childWithProps = useMemo(() => {
    if (typeof children === "function") {
      return React.createElement(children, {
        onMouseEnter: handleParentMouseLeave,
        onMouseLeave: handleParentMouseEnter,
      });
    } else {
      return React.cloneElement(children, {
        onMouseEnter: handleParentMouseLeave,
        onMouseLeave: handleParentMouseEnter,
      });
    }
  }, [children, handleParentMouseEnter, handleParentMouseLeave]);

  return childWithProps;
};
